/**
 * P3-PROPOSAL — Arial advance widths (auto-generated; DO NOT EDIT).
 */
export const BARLOW_WIDTHS: Record<'regular' | 'medium' | 'bold', Record<string, number>> = {
  "bold": {
    "32": 0.27783203125,
    "33": 0.3330078125,
    "34": 0.47412109375,
    "35": 0.55615234375,
    "36": 0.55615234375,
    "37": 0.88916015625,
    "38": 0.72216796875,
    "39": 0.23779296875,
    "40": 0.3330078125,
    "41": 0.3330078125,
    "42": 0.38916015625,
    "43": 0.583984375,
    "44": 0.27783203125,
    "45": 0.3330078125,
    "46": 0.27783203125,
    "47": 0.27783203125,
    "48": 0.55615234375,
    "49": 0.55615234375,
    "50": 0.55615234375,
    "51": 0.55615234375,
    "52": 0.55615234375,
    "53": 0.55615234375,
    "54": 0.55615234375,
    "55": 0.55615234375,
    "56": 0.55615234375,
    "57": 0.55615234375,
    "58": 0.3330078125,
    "59": 0.3330078125,
    "60": 0.583984375,
    "61": 0.583984375,
    "62": 0.583984375,
    "63": 0.61083984375,
    "64": 0.97509765625,
    "65": 0.72216796875,
    "66": 0.72216796875,
    "67": 0.72216796875,
    "68": 0.72216796875,
    "69": 0.6669921875,
    "70": 0.61083984375,
    "71": 0.77783203125,
    "72": 0.72216796875,
    "73": 0.27783203125,
    "74": 0.55615234375,
    "75": 0.72216796875,
    "76": 0.61083984375,
    "77": 0.8330078125,
    "78": 0.72216796875,
    "79": 0.77783203125,
    "80": 0.6669921875,
    "81": 0.77783203125,
    "82": 0.72216796875,
    "83": 0.6669921875,
    "84": 0.61083984375,
    "85": 0.72216796875,
    "86": 0.6669921875,
    "87": 0.94384765625,
    "88": 0.6669921875,
    "89": 0.6669921875,
    "90": 0.61083984375,
    "91": 0.3330078125,
    "92": 0.27783203125,
    "93": 0.3330078125,
    "94": 0.583984375,
    "95": 0.55615234375,
    "96": 0.3330078125,
    "97": 0.55615234375,
    "98": 0.61083984375,
    "99": 0.55615234375,
    "100": 0.61083984375,
    "101": 0.55615234375,
    "102": 0.3330078125,
    "103": 0.61083984375,
    "104": 0.61083984375,
    "105": 0.27783203125,
    "106": 0.27783203125,
    "107": 0.55615234375,
    "108": 0.27783203125,
    "109": 0.88916015625,
    "110": 0.61083984375,
    "111": 0.61083984375,
    "112": 0.61083984375,
    "113": 0.61083984375,
    "114": 0.38916015625,
    "115": 0.55615234375,
    "116": 0.3330078125,
    "117": 0.61083984375,
    "118": 0.55615234375,
    "119": 0.77783203125,
    "120": 0.55615234375,
    "121": 0.55615234375,
    "122": 0.5,
    "123": 0.38916015625,
    "124": 0.27978515625,
    "125": 0.38916015625,
    "126": 0.583984375,
    "169": 0.73681640625,
    "174": 0.73681640625,
    "176": 0.39990234375
  },
  "regular": {
    "32": 0.27783203125,
    "33": 0.27783203125,
    "34": 0.35498046875,
    "35": 0.55615234375,
    "36": 0.55615234375,
    "37": 0.88916015625,
    "38": 0.6669921875,
    "39": 0.19091796875,
    "40": 0.3330078125,
    "41": 0.3330078125,
    "42": 0.38916015625,
    "43": 0.583984375,
    "44": 0.27783203125,
    "45": 0.3330078125,
    "46": 0.27783203125,
    "47": 0.27783203125,
    "48": 0.55615234375,
    "49": 0.55615234375,
    "50": 0.55615234375,
    "51": 0.55615234375,
    "52": 0.55615234375,
    "53": 0.55615234375,
    "54": 0.55615234375,
    "55": 0.55615234375,
    "56": 0.55615234375,
    "57": 0.55615234375,
    "58": 0.27783203125,
    "59": 0.27783203125,
    "60": 0.583984375,
    "61": 0.583984375,
    "62": 0.583984375,
    "63": 0.55615234375,
    "64": 1.01513671875,
    "65": 0.6669921875,
    "66": 0.6669921875,
    "67": 0.72216796875,
    "68": 0.72216796875,
    "69": 0.6669921875,
    "70": 0.61083984375,
    "71": 0.77783203125,
    "72": 0.72216796875,
    "73": 0.27783203125,
    "74": 0.5,
    "75": 0.6669921875,
    "76": 0.55615234375,
    "77": 0.8330078125,
    "78": 0.72216796875,
    "79": 0.77783203125,
    "80": 0.6669921875,
    "81": 0.77783203125,
    "82": 0.72216796875,
    "83": 0.6669921875,
    "84": 0.61083984375,
    "85": 0.72216796875,
    "86": 0.6669921875,
    "87": 0.94384765625,
    "88": 0.6669921875,
    "89": 0.6669921875,
    "90": 0.61083984375,
    "91": 0.27783203125,
    "92": 0.27783203125,
    "93": 0.27783203125,
    "94": 0.46923828125,
    "95": 0.55615234375,
    "96": 0.3330078125,
    "97": 0.55615234375,
    "98": 0.55615234375,
    "99": 0.5,
    "100": 0.55615234375,
    "101": 0.55615234375,
    "102": 0.27783203125,
    "103": 0.55615234375,
    "104": 0.55615234375,
    "105": 0.22216796875,
    "106": 0.22216796875,
    "107": 0.5,
    "108": 0.22216796875,
    "109": 0.8330078125,
    "110": 0.55615234375,
    "111": 0.55615234375,
    "112": 0.55615234375,
    "113": 0.55615234375,
    "114": 0.3330078125,
    "115": 0.5,
    "116": 0.27783203125,
    "117": 0.55615234375,
    "118": 0.5,
    "119": 0.72216796875,
    "120": 0.5,
    "121": 0.5,
    "122": 0.5,
    "123": 0.333984375,
    "124": 0.259765625,
    "125": 0.333984375,
    "126": 0.583984375,
    "169": 0.73681640625,
    "174": 0.73681640625,
    "176": 0.39990234375
  },
  "medium": {
    "32": 0.27783203125,
    "33": 0.27783203125,
    "34": 0.35498046875,
    "35": 0.55615234375,
    "36": 0.55615234375,
    "37": 0.88916015625,
    "38": 0.6669921875,
    "39": 0.19091796875,
    "40": 0.3330078125,
    "41": 0.3330078125,
    "42": 0.38916015625,
    "43": 0.583984375,
    "44": 0.27783203125,
    "45": 0.3330078125,
    "46": 0.27783203125,
    "47": 0.27783203125,
    "48": 0.55615234375,
    "49": 0.55615234375,
    "50": 0.55615234375,
    "51": 0.55615234375,
    "52": 0.55615234375,
    "53": 0.55615234375,
    "54": 0.55615234375,
    "55": 0.55615234375,
    "56": 0.55615234375,
    "57": 0.55615234375,
    "58": 0.27783203125,
    "59": 0.27783203125,
    "60": 0.583984375,
    "61": 0.583984375,
    "62": 0.583984375,
    "63": 0.55615234375,
    "64": 1.01513671875,
    "65": 0.6669921875,
    "66": 0.6669921875,
    "67": 0.72216796875,
    "68": 0.72216796875,
    "69": 0.6669921875,
    "70": 0.61083984375,
    "71": 0.77783203125,
    "72": 0.72216796875,
    "73": 0.27783203125,
    "74": 0.5,
    "75": 0.6669921875,
    "76": 0.55615234375,
    "77": 0.8330078125,
    "78": 0.72216796875,
    "79": 0.77783203125,
    "80": 0.6669921875,
    "81": 0.77783203125,
    "82": 0.72216796875,
    "83": 0.6669921875,
    "84": 0.61083984375,
    "85": 0.72216796875,
    "86": 0.6669921875,
    "87": 0.94384765625,
    "88": 0.6669921875,
    "89": 0.6669921875,
    "90": 0.61083984375,
    "91": 0.27783203125,
    "92": 0.27783203125,
    "93": 0.27783203125,
    "94": 0.46923828125,
    "95": 0.55615234375,
    "96": 0.3330078125,
    "97": 0.55615234375,
    "98": 0.55615234375,
    "99": 0.5,
    "100": 0.55615234375,
    "101": 0.55615234375,
    "102": 0.27783203125,
    "103": 0.55615234375,
    "104": 0.55615234375,
    "105": 0.22216796875,
    "106": 0.22216796875,
    "107": 0.5,
    "108": 0.22216796875,
    "109": 0.8330078125,
    "110": 0.55615234375,
    "111": 0.55615234375,
    "112": 0.55615234375,
    "113": 0.55615234375,
    "114": 0.3330078125,
    "115": 0.5,
    "116": 0.27783203125,
    "117": 0.55615234375,
    "118": 0.5,
    "119": 0.72216796875,
    "120": 0.5,
    "121": 0.5,
    "122": 0.5,
    "123": 0.333984375,
    "124": 0.259765625,
    "125": 0.333984375,
    "126": 0.583984375,
    "169": 0.73681640625,
    "174": 0.73681640625,
    "176": 0.39990234375
  }
};
